import React from 'react'
import { branch } from 'baobab-react/higher-order'

import BaseTemplate from 'components/templates/BaseTemplate'

import PaperplaneSummary from './PaperplaneSummary'
import PaperplaneFAQ from './PapeplaneFAQ'
import PaperplaneRecommendation from './PaperplaneRecommendation'
import PaperplaneResultWaiting from '../Paperplane/PaperplaneResultWaiting'

const PaperplaneResult = ({ has_result: hasResult, recomendation1, recomendation2 }) => {
  if (!hasResult) {
    return <PaperplaneResultWaiting />
  }
  return (
    <BaseTemplate useNewHeader useNewBreadcrumb>
      <PaperplaneSummary />
      <PaperplaneRecommendation recomendation1={recomendation1} recomendation2={recomendation2} />
      <PaperplaneFAQ />
    </BaseTemplate>
  )
}

export { PaperplaneResult }
export default branch({
  recomendation1: ['serverProps', 'option_1', 'recommendations'],
  recomendation2: ['serverProps', 'option_2', 'recommendations'],
  has_result: ['serverProps', 'has_result'],
}, PaperplaneResult)
